import api from './api';

/**
 * Options for the Pro Detail "CST Dispatcher" dropdown — active BROKERAGE-group
 * users from the GWI users DB. `value` is the username (saved to
 * orders.cstdispatcher); `label` is the uppercased full name.
 *
 * Small, effectively static within a session — cached in module scope like the
 * rails/terminal list.
 */
export interface CstDispatcherOption {
  value: string;
  label: string;
}

let cache: Promise<CstDispatcherOption[]> | null = null;

export async function getCstDispatchers(): Promise<CstDispatcherOption[]> {
  if (!cache) {
    cache = api
      .get<CstDispatcherOption[]>('/admin/cst-dispatchers')
      .then((r) => r.data)
      .catch((err) => {
        cache = null; // allow a retry on the next mount
        console.error('Failed to load CST dispatchers', err);
        return [];
      });
  }
  return cache;
}
